import { render, staticRenderFns } from "./WhrjFooter.vue?vue&type=template&id=0bc4fefb&scoped=true&"
import script from "./WhrjFooter.vue?vue&type=script&lang=js&"
export * from "./WhrjFooter.vue?vue&type=script&lang=js&"
import style0 from "./WhrjFooter.vue?vue&type=style&index=0&id=0bc4fefb&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc4fefb",
  null
  
)

export default component.exports